import { useMsal } from "@azure/msal-react";
import { type SxProps, type Theme } from "@mui/material/styles";

import { Button } from "ui/button";

import useSetPageTitle from "hooks/use-set-page-title";

import { loginRequest } from "config/auth-config";

import Icons from "assets";
import { env } from "env";

import { DeployInfo } from "./deploy-info";

const LOGIN_BUTTON_SX: SxProps<Theme> = { px: 10, mt: 5 };

const LoginPage = () => {
  const { instance } = useMsal();

  function adfsLogin() {
    instance.loginRedirect(loginRequest);
  }

  const isClientUser = true;
  const pageTitle = "Sign In";
  const showDeployInfo = env.REACT_APP_ENV !== "prod";

  useSetPageTitle({ isClientUser, pageTitle });

  return (
    <div className="flex flex-col items-center align-center justify-center h-full">
      <div className="flex flex-col items-center align-center justify-center h-[85%]">
        <Icons.ApolloLogo customClass="text-navy-800 w-96 mr-4" />
        <Button size="large" color="secondary" onClick={adfsLogin} sx={LOGIN_BUTTON_SX}>
          Login
        </Button>
      </div>
      <Icons.TwoOceanLogo customClass="text-navy-800 w-44 mr-10" />
      {showDeployInfo && <DeployInfo />}
    </div>
  );
};

export default LoginPage;
